<template>

    <div class="container">

        <app-head title="Delivery Options" />
        
        <back :href="route('admin.suppliers.index')" />

        <div class="d-flex justify-content-start align-items-center mb-3 gap-3">
            <h1 class="">{{ __('Delivery Options') }}: {{ supplier.short_name }}</h1>
            <div class="">
                <inertia-link class="btn btn-primary" :href="route('admin.suppliers.delivery-options.create', supplier)">
                    {{ __('Create') }}
                </inertia-link>
            </div>
        </div>

        <div class="d-flex mb-3">
            <search-filter v-model="form.search" class="" @reset="reset">
            </search-filter>
        </div>

        <div class="d-flex justify-content-between">
            <results :meta="deliveryOptions.meta" />
        </div>

        <div class="card">
            <data-table :items="deliveryOptions.data"
                        :links="deliveryOptions.meta.links"
                        :columns="columns"
                        >
                <data-table-row v-for="deliveryOption in deliveryOptions.data" :key="deliveryOption.id">
                    <td>
                        {{ deliveryOption.id }}
                    </td>
                    <td>
                        <inertia-link class=" stretched-link" :href="route('admin.delivery-options.edit', deliveryOption)">
                            {{ deliveryOption.name }}
                        </inertia-link>
                    </td>
                    <td>
                        <boolean :value="deliveryOption.enabled" />
                    </td>
                    <td>
                        {{ deliveryOption.sort_order }}
                    </td>
                    <td>
                        {{ deliveryOption.created_at | localizeDateTime }}
                    </td>
                    <td class="text-end">
                        <i class="bi bi-chevron-right"></i>
                    </td>
                </data-table-row>
            </data-table>
        </div>

    </div>

</template>

<script>

    import DataTable from '@/shared/Admin/DataTable';
    import DataTableRow from '@/shared/Admin/DataTableRow';
    import SearchFilter from '@/shared/Admin/SearchFilter';
    import SelectInput from '@/shared/Inputs/SelectInput';

    import Boolean from '@/shared/Admin/Boolean';

    import Results from '@/shared/Admin/Results';

    export default {
        props: [
            'filters',
            'supplier',
            'deliveryOptions',
        ],
        components: {
            DataTable,
            DataTableRow,
            SearchFilter,
            SelectInput,
            Results,
            Boolean,
        },
        data() {
            return {
                form: {
                    search: this.filters.search,
                },
                columns: {
                    id: {label: 'ID', sortable: 'id'},
                    name: {label: 'Name', sortable: 'name'},
                    enabled: {label: 'Enabled', sortable: 'enabled'},
                    sort_order: {label: 'Sort order', sortable: 'sort_order'},
                    created_at: {label: 'Created', sortable: 'created_at'},
                },
            }
        },
        watch: {
            form: {
                deep: true,
                handler: _.debounce(function () {
                    this.$inertia.get(this.route('admin.suppliers.delivery-options.index', this.supplier), this.form, {preserveState: true})
                }, 300, {trailing: true}),
            },
        },
        methods: {
            reset() {
                this.form = _.mapValues(this.form, () => null)
            },
        },
    }
</script>